import _ from 'lodash';
import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  CHANGE_CART_DRAWER,
  REPLACE_ITEM_IN_CART,
} from '../actions/types';

const defaultState = {
  isDrawerOpen: false,
  items: [],
};

/**
 * Checks to see, you guessed it, if an object has an item.
 * @param {Array<Object>} collection - Collection of objects we want to check.
 * @param {Object} object - Checks to see if the object exists in the collection.
 * @returns {Boolean} - True if it exists, false otherwise.
 */
const hasItem = (collection, object) => !_.isEmpty(_.find(collection, object));

/**
 * Cart reducer logic.
 * @param {Object} state - The state for this reducer in Redux.
 * @param {Object} action - The action which details what to do & what state to update.
 * @returns {Object} - Newly created state object.
 */
export default (state = defaultState, action) => {
  const type = _.get(action.payload, 'item.type', '');
  const id = _.get(action.payload, 'item.id', '');
  const isDrawerOpen = _.get(action, 'payload.isDrawerOpen', state.isDrawerOpen);

  switch (action.type) {
    case ADD_TO_CART:
      return hasItem(state.items, { id, type })
        ? { ...state, isDrawerOpen }
        : { items: [...state.items, action.payload.item], isDrawerOpen };

    case REPLACE_ITEM_IN_CART:
      return {
        items: _.map(state.items, (item) => {
          if (item.id === id) return action.payload.item;
          return item;
        }),
        isDrawerOpen,
      };

    case REMOVE_FROM_CART:
      return {
        items: _.filter(
          state.items, i => !(i.id === id && i.type === type),
        ),
        isDrawerOpen,
      };

    case CHANGE_CART_DRAWER:
      return { ...state, isDrawerOpen };

    default:
      return state;
  }
};
